import { Alert, Col, Row, Table } from 'antd';
import React from 'react';
import {
  GetARateQuery,
  GetGlobalRateQuery,
} from '../../../graphql/datamodel.gen';
import { SortOrder } from 'antd/lib/table/interface';

interface VehicleCategoriesProps {
  rate: GetGlobalRateQuery['globalRate'];
}

type VehicleCategoryRow = GetARateQuery['rate']['vehicleCategories'][0];

const VehicleCategories: React.FC<VehicleCategoriesProps> = (
  props: VehicleCategoriesProps,
) => {
  const { rate } = props;
  const columns = [
    {
      title: 'Nombre de categoría',
      dataIndex: 'name',
      defaultSortOrder: 'ascend' as SortOrder,
      sorter: (catA: VehicleCategoryRow, catB: VehicleCategoryRow) => {
        return catA.name?.localeCompare(catB.name);
      },
    },
    {
      title: 'Descripción',
      dataIndex: 'description',
    },
    {
      title: 'Tipo de vehículo',
      dataIndex: ['vehicleType', 'name'],
      render: (value?: string) => {
        return value?.toUpperCase();
      },
      sorter: (catA: VehicleCategoryRow, catB: VehicleCategoryRow) => {
        return catA.vehicleType?.name?.localeCompare(catB.vehicleType?.name);
      },
    },
    {
      title: 'Marca de vehículo',
      dataIndex: ['vehicleBrand', 'brand'],
      render: (value?: string) => {
        return value?.toUpperCase();
      },
      sorter: (catA: VehicleCategoryRow, catB: VehicleCategoryRow) => {
        return catA.vehicleBrand?.brand?.localeCompare(
          catB.vehicleBrand?.brand,
        );
      },
    },
    {
      title: 'Modelo de vehículo',
      dataIndex: ['vehicleModel', 'name'],
      render: (value?: string) => {
        return value?.toUpperCase();
      },
      sorter: (catA: VehicleCategoryRow, catB: VehicleCategoryRow) => {
        return catA.vehicleModel?.name?.localeCompare(catB.vehicleModel?.name);
      },
    },
    {
      title: 'Capacidad',
      dataIndex: ['vehicleCapacity'],
      render: (value?: number) => {
        if (value === 0) {
          return null;
        }

        return value;
      },
      sorter: (catA: VehicleCategoryRow, catB: VehicleCategoryRow) => {
        return catA.vehicleCapacity || 0 - catB.vehicleCapacity || 0;
      },
    },
  ];

  return (
    <>
      <Row>
        <Col span={24}>
          <Alert
            style={{ marginBottom: '2rem' }}
            message="Una categoría de vehículo representa una combinación de tipo de vehículo, marca, modelo y capacidad. El nombre de cada categoría será mostrado al cliente para que pueda elegir una categoría al crear un presupuesto"
          />
          <Table columns={columns} dataSource={rate?.vehicleCategories} />
        </Col>
      </Row>
    </>
  );
};

export default VehicleCategories;
